import { postData, getData, putData, deleteData } from '../services/axiosServices'

export const loginData = (email,token) => {
    let url = 'learners/login'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`

    }
    return postData(url, { email }, { headers })
}